/*gen*/ export const white = '#ffffff';
/*gen*/ export const black = '#000000';
/*gen*/ export const gold50 = '#fcf8ee';
/*gen*/ export const gold100 = '#dfab29';
/*gen*/ export const gold200 = '#ac8420';
/*gen*/ export const neutral50 = '#f6f7f9';
/*gen*/ export const neutral60 = '#ecedef';
/*gen*/ export const neutral80 = '#dfe1e4';
/*gen*/ export const neutral100 = '#d3d6da';
/*gen*/ export const neutral200 = '#b1b8be';
/*gen*/ export const neutral300 = '#929aa3';
/*gen*/ export const neutral400 = '#747c87';
/*gen*/ export const neutral500 = '#565e6d';
/*gen*/ export const neutral600 = '#374050';
/*gen*/ export const neutral700 = '#152235';
/*gen*/ export const neutral800 = '#051225';
/*gen*/ export const blue50 = '#e6f5ff';
/*gen*/ export const blue100 = '#bbe8ff';
/*gen*/ export const blue200 = '#82c8ff';
/*gen*/ export const blue300 = '#50aaff';
/*gen*/ export const blue400 = '#3181ff';
/*gen*/ export const blue500 = '#1e55eb';
/*gen*/ export const blue600 = '#192d9b';
/*gen*/ export const red50 = '#fff0f2';
/*gen*/ export const red100 = '#ffd7dc';
/*gen*/ export const red200 = '#ffaeb9';
/*gen*/ export const red300 = '#ff7d91';
/*gen*/ export const red400 = '#fa375a';
/*gen*/ export const red500 = '#c8002d';
/*gen*/ export const red600 = '#7d002d';
/*gen*/ export const teal50 = '#e1fffa';
/*gen*/ export const teal100 = '#9bf5f5';
/*gen*/ export const teal200 = '#5fe1e1';
/*gen*/ export const teal300 = '#00c6c6';
/*gen*/ export const teal400 = '#00a0aa';
/*gen*/ export const teal500 = '#00717f';
/*gen*/ export const teal600 = '#004b64';
/*gen*/ export const green50 = '#f0ffcd';
/*gen*/ export const green100 = '#bcfc8f';
/*gen*/ export const green200 = '#85e870';
/*gen*/ export const green300 = '#44cb67';
/*gen*/ export const green400 = '#1aa651';
/*gen*/ export const green500 = '#007850';
/*gen*/ export const green600 = '#004f3f';
/*gen*/ export const orange50 = '#fffec3';
/*gen*/ export const orange100 = '#fff00a';
/*gen*/ export const orange200 = '#ffc805';
/*gen*/ export const orange300 = '#ff9105';
/*gen*/ export const orange400 = '#f05a0f';
/*gen*/ export const orange500 = '#c83205';
/*gen*/ export const orange600 = '#801705';
/*gen*/ export const purple50 = '#ffebff';
/*gen*/ export const purple100 = '#ffc8ff';
/*gen*/ export const purple200 = '#ff96fc';
/*gen*/ export const purple300 = '#fd6afa';
/*gen*/ export const purple400 = '#e628e1';
/*gen*/ export const purple500 = '#a409b8';
/*gen*/ export const purple600 = '#62008f';
/*gen*/ export const violet100 = '#ddccff';
/*gen*/ export const violet200 = '#c4a6ff';
/*gen*/ export const violet300 = '#aa85f2';
/*gen*/ export const violet400 = '#8250e5';
/*gen*/ export const violet500 = '#6030bf';
/*gen*/ export const violet600 = '#481f99';
/*gen*/ export const AIViolet40 = '#f0edff';
/*gen*/ export const AIViolet50 = '#e5ffff';
/*gen*/ export const AIViolet60 = '#d4f8ff';
/*gen*/ export const AIViolet80 = '#c4e9ff';
/*gen*/ export const AIViolet100 = '#b5d4ff';
/*gen*/ export const AIViolet200 = '#a7b9ff';
/*gen*/ export const AIViolet300 = '#989aff';
/*gen*/ export const AIViolet400 = '#a259ff';
/*gen*/ export const AIViolet500 = '#9b64bf';
/*gen*/ export const AIViolet600 = '#93529f';
/*gen*/ export const AIViolet700 = '#804080';
/*gen*/
